<article>
  <div class="zone-indication" fxFlex fxLayout="row" fxLayoutAlign="start center">
    <span class="label" *ngIf="isZonesInstanceOfFreeZone(zones[0])">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.FREE_ZONE.FREE_ZONE' | bmsTranslate: {count: 1} }}</span>
    <span class="label" *ngIf="isZonesInstanceOfRestZone(zones[0])">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.REST_ZONE.REST_ZONE' | bmsTranslate: {count: 1} }}</span>

    <div
      *ngIf="canShowZoneIndicators()"
      [style.width.px]="productionScheduleBuilderWidth"
      class="zone-indicator-line"
      [class.free-zone]="isZonesInstanceOfFreeZone(zones[0])"
      [class.rest-zone]="isZonesInstanceOfRestZone(zones[0])"
    >
      <div
        *ngFor="let zone of zones; let zoneIndex = index"
        fxLayout="column"
        fxLayoutAlign="center center"
        [style.left.px]="getZoneIndicatorPosition(zoneIndex)"
        class="zone-container"
        #zoneIndicatorContainerElements
      >
        <div class="zone-indicator-container">
          <div *ngIf="hasZoneWarnings(zone)" class="notification warning"></div>
          <div *ngIf="hasZoneErrors(zone)" class="notification error"></div>

          <mat-icon
            class="zone-indicator"
            [ngClass]="{
              selected: isZoneSelected(zoneIndex),
              modified: hasZoneBeenModified(zone, zoneIndex),
              'has-errors': hasZoneErrors(zone),
              'has-warnings': hasZoneWarnings(zone)
            }"
            [svgIcon]="getZoneIcon(zoneIndex)"
            (click)="onClickZoneIndicator(zoneIndex, zoneIndicatorContainerElements)"
          ></mat-icon>
        </div>

        <span class="zone-width">{{ getZoneWidth(zone) }}</span>
      </div>
    </div>
  </div>
</article>
